import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { ridesCalendarRowsFilterAtom } from "./rides-calendar.atoms";
import {
  RIDES_CALENDAR_ROWS_FILTER_DEFAULT_LABELS,
  RIDES_CALENDAR_ROWS_FILTER_LABEL_KEYS,
  RIDES_CALENDAR_ROWS_FILTER_MIN_WIDTH_PX,
  RIDES_CALENDAR_ROWS_FILTER_VALUES,
} from "./rides-calendar.constants";
import { RidesCalendarRowsFilter } from "./rides-calendar.models";

export const RidesCalendarRowsFilterSelect: FC = () => {
  const { t } = useTranslation();
  const [value, setValue] = useRecoilState(ridesCalendarRowsFilterAtom);

  const options = useMemo(
    () =>
      RIDES_CALENDAR_ROWS_FILTER_VALUES.map(v => ({
        value: v,
        label: t(RIDES_CALENDAR_ROWS_FILTER_LABEL_KEYS[v], {
          defaultValue: RIDES_CALENDAR_ROWS_FILTER_DEFAULT_LABELS[v],
        }),
      })),
    [t],
  );

  const handleChange = (
    event: SelectChangeEvent<RidesCalendarRowsFilter>,
  ): void => {
    const next = event.target.value as RidesCalendarRowsFilter;
    if (RIDES_CALENDAR_ROWS_FILTER_VALUES.includes(next)) {
      setValue(next);
    }
  };

  return (
    <FormControl
      size="small"
      variant="standard"
      sx={{
        minWidth: RIDES_CALENDAR_ROWS_FILTER_MIN_WIDTH_PX,
        marginInlineEnd: "16px",
      }}
    >
      <Select
        value={value}
        onChange={handleChange}
        data-e2e="rides-calendar-rows-filter"
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
